// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#257E43","content":"styles_content__13TfV","formContainer":"styles_formContainer__36r6M","base":"styles_base__2idBe"};